// 根据不同的域名设置不同的 shopId
var currentDomain = window.location.hostname;

// 测试域名变量
if (currentDomain === 'heychic-test-store.myshopify.com') {
    localStorage.setItem('shopId', '66793275449');
}else {
    localStorage.setItem('shopId', '59363262637');
}

// 测试域名
// var heychic_api = 'https://test-user-api.heychic.net';
// 正式域名
var heychic_api = 'https://user-api.heychic.net';

// var shopIdAuth = '66793275449';//测试 
var shopIdAuth = '59363262637';//au
// var shopIdAuth = '79421964578';//usa

// 评论上传文件至服务器
// var img_video_upload = 'https://tcdn.heychic.net/comment/';//测试
var img_video_upload = 'https://cdn.heychic.net/comment/';//正式

//graphql相关
// var graphql_api = 'https://heychic-test-store.myshopify.com';//测试
var graphql_api = 'https://heychic-com-au.myshopify.com';//正式

// var graphql_token = '2ec63bf90823df5100681407fc939e77';//测试
var graphql_token = '28b6e01d4304fc12c8b514799e0aa497';//正式


// 退货面单上传文件至服务器
// var img_upload_return = 'https://tcdn.heychic.net/refund/return/';//测试
var img_upload_return = 'https://cdn.heychic.net/refund/return/';//正式

// 获取url的token
function getUrlParameter(name) {
    const urlParamsCont = new URLSearchParams(window.location.search);
    return urlParamsCont.get(name);
}
var urlParams_token = getUrlParameter('hc_token');
var authorization = localStorage.getItem('hc_token') || urlParams_token;


// 删除cookie
function deleteAllCookies() {
    console.log("删除cookie")
    localStorage.clear();
    // 获取所有的 cookie
    const cookies = document.cookie.split(';');

    // 遍历所有的 cookie，并将它们的过期时间设置为过去的日期
    cookies.forEach(cookie => {
        const cookieName = cookie.split('=')[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });
}


// function getCustomerSign(data = {}) {
//   let timestamp = Math.floor(new Date().getTime() / 1000);
//   let nonce_str = generateUniqueId(); // 生成 16 位随机字符串

//   // 处理 data，确保所有值为字符串类型
//   let processed_data = {};
//   Object.keys(data).forEach(key => {
//     processed_data[key] = (data[key] === null || data[key] === undefined) 
//                           ? "" 
//                           : (typeof data[key] === "object" ? JSON.stringify(data[key]) : String(data[key]));
//   });

//   // 添加系统参数
//   processed_data.timestamp = timestamp;
//   processed_data.nonce_str = nonce_str;

//   // 按键排序
//   let sortedKeys = Object.keys(processed_data).sort();

//   // 生成 key=value 形式的字符串
//   let time_data_list = sortedKeys.map(key => `${key}=${processed_data[key]}`).join('&');

//   // 计算 MD5
//   let time_data_md5 = md5(time_data_list);
//   let token_sign = md5(authorization); // 对 token 进行 MD5
//   if(window.location.pathname == "/pages/bf-lottery"){ // 如果是抽奖页面，则不进行token_sign验证
//     token_sign = '';
//   }
//   let sign_str = md5(time_data_md5 + '45f0b16430a64a3d061e75ff13891e0a' + token_sign); // 计算签名

//   // 赋值 sign
//   processed_data.sign = sign_str;

//   return processed_data; // 返回带签名的数据
// }

// 签名js混淆
// var _0x1698=['forEach','join','map','stringify','keys','nonce_str','sign'];var _0x3914=function(_0x169862,_0x391443){_0x169862=_0x169862-0x0;let _0x58d762=_0x1698[_0x169862];return _0x58d762;};function getCustomerSign(_0x5c1319={}){let _0x23661c=Math['floor'](new Date()['getTime']()/0x3e8);let _0x1f4a7c=generateUniqueId();let _0x3e2048={};Object[_0x3914('0x4')](_0x5c1319)[_0x3914('0x0')](_0x5f1829=>{_0x3e2048[_0x5f1829]=_0x5c1319[_0x5f1829]===null||_0x5c1319[_0x5f1829]===undefined?'':typeof _0x5c1319[_0x5f1829]==='object'?JSON[_0x3914('0x3')](_0x5c1319[_0x5f1829]):String(_0x5c1319[_0x5f1829]);});_0x3e2048['timestamp']=_0x23661c;_0x3e2048[_0x3914('0x5')]=_0x1f4a7c;let _0x5df518=Object[_0x3914('0x4')](_0x3e2048)['sort']();let _0x58530f=_0x5df518[_0x3914('0x2')](_0x18226f=>_0x18226f+'='+_0x3e2048[_0x18226f])[_0x3914('0x1')]('&');let _0x4aee10=md5(_0x58530f);let _0x5c2a79=md5(authorization);let _0x1c811a=md5(_0x4aee10+'45f0b16430a64a3d061e75ff13891e0a'+_0x5c2a79);_0x3e2048[_0x3914('0x6')]=_0x1c811a;return _0x3e2048;}
var _0x33e0=['keys','join','getTime','sign','map','location','/pages/bf-lottery'];var _0x1853=function(_0x33e0e5,_0x185390){_0x33e0e5=_0x33e0e5-0x0;let _0x397fb5=_0x33e0[_0x33e0e5];return _0x397fb5;};function getCustomerSign(_0xf2096c={}){let _0x5479c1=Math['floor'](new Date()[_0x1853('0x2')]()/0x3e8);let _0x377c30=generateUniqueId();let _0x2af0ec={};Object[_0x1853('0x0')](_0xf2096c)['forEach'](_0x47e593=>{_0x2af0ec[_0x47e593]=_0xf2096c[_0x47e593]===null||_0xf2096c[_0x47e593]===undefined?'':typeof _0xf2096c[_0x47e593]==='object'?JSON['stringify'](_0xf2096c[_0x47e593]):String(_0xf2096c[_0x47e593]);});_0x2af0ec['timestamp']=_0x5479c1;_0x2af0ec['nonce_str']=_0x377c30;let _0x41071d=Object[_0x1853('0x0')](_0x2af0ec)['sort']();let _0x370298=_0x41071d[_0x1853('0x4')](_0x2ecb0f=>_0x2ecb0f+'='+_0x2af0ec[_0x2ecb0f])[_0x1853('0x1')]('&');let _0x4c82de=md5(_0x370298);let _0x4693d2=md5(authorization);if(window[_0x1853('0x5')]['pathname']==_0x1853('0x6')){_0x4693d2='';}let _0x5ebccb=md5(_0x4c82de+'45f0b16430a64a3d061e75ff13891e0a'+_0x4693d2);_0x2af0ec[_0x1853('0x3')]=_0x5ebccb;return _0x2af0ec;}
// 定义时间格式化方法
function formatUTCToLocal(utcTimeString, format,type) {
  const date = new Date(utcTimeString);
  const year = date.getFullYear();
  let month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，所以要加 1
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const hour12 = String(date.getHours() % 12 || 12).padStart(2, "0");
	let allTime = '';//时分秒
  const monthList = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  if (format == "us") {
    monthList.forEach((e, index) => {
      if (index + 1 == month) {
        month = e;
      }
    });
  }

	if(type !== 'review'){
		// review页面不显示时分秒
		if(format == 'us'){
			allTime = `${hour12}:${minutes}:${seconds} ${ampm}`;
		}else{
			allTime = `${hours}:${minutes}:${seconds}`;
		}
	}

  switch (format) {
    case "us":
      return `${month} ${day},${year} ${allTime}`;
    case "au":
      return `${day}/${month}/${year} ${allTime}`;
    default:
      return `${year}-${month}-${day} ${allTime}`;
  }
}

// 获取当前时区
function getCurrentTimeZone() {
    // 获取当前时区与 UTC 的偏移量（单位：分钟）
    var offsetMinutesCoupon = new Date().getTimezoneOffset();
    var offsetHoursCoupon = Math.floor(Math.abs(offsetMinutesCoupon) / 60);
    var signCoupon = offsetMinutesCoupon > 0 ? '-' : '+';

    // 获取时区名称
    var timeZoneNameCoupon = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return {
        offsetHoursCoupon,
        signCoupon,
        timeZoneNameCoupon
    };
}

// 根据时区名称判断地理位置
function getCountryFromTimeZone(timeZoneNameCoupon) {
    if (timeZoneNameCoupon.startsWith('America/') || timeZoneNameCoupon === 'Pacific/Honolulu') {
        return 'us';
    } else if (timeZoneNameCoupon.startsWith('Australia/')) {
        return 'au';
    }
    return 'default';
}

var { timeZoneNameCoupon } = getCurrentTimeZone();
var countryCom = getCountryFromTimeZone(timeZoneNameCoupon);

// 时间转为 November 21, 2025格式
function formatDateToEnglishUTC(dateString) {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' };
  return date.toLocaleDateString('en-US', options);
}

// 时间转为 21 November 2025格式
function formatDateToEnglishUTCNew(dateString) {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' };
  const formatted = date.toLocaleDateString('en-GB', options); // 英式格式是 “day month year”
  return formatted.replace(',', ''); // 去掉逗号，得到 “30 October 2025”
}

// 判断时间是否过期 2025-10-31T23:59:59+11:00
function isRefundLabelExpired(endTimeString) {
  const nowUTC = new Date(); // 当前时间（内部以 UTC 存储）
  const endTime = new Date(endTimeString); // 自动识别 "+11:00" 时区并换算为 UTC
  return nowUTC > endTime; // true 表示当前UTC时间已超过截止时间
}



// 接口组件
// 默认请求头配置
var defaultHeaders = {
    "Content-Type": "application/json",
    Authorization: authorization, // 从你的全局变量中获取
    "X-Shop-Id": shopIdAuth, // 从你的全局变量中获取
};

/**
 * 通用请求函数
 * @param {string} url - 请求的 URL
 * @param {string} method - 请求方法 (GET, POST, PUT, DELETE)
 * @param {object} [customHeaders={}] - 自定义请求头
 * @param {object|null} [body=null] - 请求体 (仅适用于 POST/PUT)
 * @returns {Promise<object>} - 返回一个 Promise，解析为 JSON 数据
 */
function fetchRequest(url, method, customHeaders = {}, body = null) {
    const headers = { ...defaultHeaders, ...customHeaders };
    const options = {
        method,
        headers,
    };

    // 仅在 POST/PUT 请求时添加请求体
    if (body && (method === "POST" || method === "PUT")) {
        options.body = JSON.stringify(body);
    }

    return fetch(url, options)
        .then((response) => {
            if (!response.ok) {
                // 统一处理错误状态
                if (response.status === 401 || response.status === 404) {
                    deleteAllCookies(); // 清除 Cookies
                    window.location.href = "/account/logout"; // 跳转到登出页面
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // 解析 JSON 数据
        })
        .catch((error) => {
            console.error("Request Error:", error);
            throw error; // 将错误抛出供调用者捕获
        });
}

function getCurrencySymbolAll(currencyCode) {
  const currencySymbols = {
      "USD": "$",
      "EUR": "€",
      "JPY": "¥",
      "GBP": "£",
      "AUD": "$",
      "CAD": "$",
      "CHF": "Fr",
      "CNY": "¥",
      "SEK": "kr",
      "NZD": "$",
      "KRW": "₩",
      "SGD": "$",
      "NOK": "kr",
      "MXN": "$",
      "INR": "₹",
      "RUB": "₽",
      "ZAR": "R",
      "BRL": "R$",
      "TRY": "₺",
      "HKD": "HK$",
      "IDR": "Rp",
      "ISK": "kr",
      "PHP": "₱",
      "DKK": "kr",
      "PLN": "zł",
      "HUF": "Ft",
      "CZK": "Kč",
      "THB": "฿",
      "MYR": "RM",
      "HRK": "kn",
      "RON": "lei",
      "ILS": "₪",
      "CLP": "$",
      "AED": "د.إ",
      "COP": "$",
      "SAR": "﷼",
      "BGN": "лв",
      "PKR": "₨",
      "EGP": "£",
      "DZD": "د.ج",
      "KWD": "د.ك",
      "QAR": "﷼",
      "KES": "KSh",
      "VND": "₫",
      "ARS": "$",
      "TWD": "NT$",
      "BDT": "৳",
      "NPR": "₨",
      "IQD": "ع.د",
      "COP": "COL$",
      "LKR": "Rs",
      "UGX": "USh",
      "GHS": "GH₵",
      "RON": "RON",
      "MAD": "د.م.",
      "UZS": "so'm"
  };

  return currencySymbols[currencyCode] || "Unknown";
}

// 转成Handle
function toHandle(str) {
  return str
    .trim()                     // 去掉前后空格
    .toLowerCase()              // 转小写
    .replace(/\s+/g, '-')       // 空格或连续空格替换为单个 "-"
    .replace(/[^a-z0-9\-]/g, '') // 移除非字母数字和连字符的字符
    .replace(/\-+/g, '-');      // 多个连字符合并为一个
}


/*
  跳转类型判断
  0: 无需跳转
  1: 系列页
  2: 产品详情
  3: pages页
  4: 自定义页
*/
window.hrefContent = function(name,type,report,report_name,jump_data) {
  if(!name && (type == 3 || type == 4)){
    name = jump_data;
  }
  if(name){
    if(type >= 0){
      let no_report = false; // 需要上报
      if(report == 0){
        no_report = true; // 不需要上报
      }
      switch (type) {
        case 0:
          detail_link = 'javascript:void(0);'
          if(report == 1){
            handleEvent(report_name)
          }
          break;
        case 1:
          detail_link = `/collections/${name}?no_report=${no_report}`;
          break;
        case 2:
          detail_link = `/products/${name}?no_report=${no_report}`;
          break;
        case 3:
          switch (name) {
            case 'index':
              detail_link = `/?no_report=${no_report}`;
              break;
            case 'wish_list':
              detail_link = `/pages/wishlist?no_report=${no_report}`;
              break;
            case 'new_design':
              detail_link = `/pages/new-design?no_report=${no_report}`;
              break;
            case 'store_locator':
              detail_link = `/pages/store-locator?no_report=${no_report}`;
              break;
            default:
              detail_link = `/pages/${name}?no_report=${no_report}`;
          }
          break;
        case 4:
          detail_link = jump_data;
          break;
      }
    }else{
      detail_link = 'javascript:void(0);'
    }
  }else{
    detail_link = 'javascript:void(0);'
  }
  return window.location.href = detail_link;
}


// 针对ios版本，蒙层出现时顶部header对应增加蒙层(安卓系统不需要，仅针对h5)
function addIOSHeaderBg(){
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

  if(isiOS){
    console.log('ios')
    $('.ios-header-mask').show();
  }
}

function removeIOSHeaderBg(){
  $('.ios-header-mask').hide();
}